<template>
  <sc-render :fields="fields" :emptyMessage="$t('NO_DATA_SOURCE_EXIST')">
    <div class="community-container">
      <div class="header">
        <sc-text v-if="isEditMode || title" class="title" tag="h4" :field="fields.title" />
        <div v-if="isEditMode || ctaHref" class="cta-container">
          <sc-link v-if="isEditMode" class="sc-link" :field="fields.cta"/>
          <sh-button
            v-else
            :naked="true"
            :[btnLinkKey]="ctaHref"
            :target="ctaTarget"
            :aria-label="ctaHiddenText || ctaText"
          >
            {{ ctaText }}
          </sh-button>
        </div>
      </div>
      <div v-if="!isEditMode" class="tiles">
        <template v-for="tile in tiles">
          <component :key="tile.id" :is="tile.value" />
        </template>
      </div>
      <sc-placeholder
        v-else
        class="container-editor"
        :rendering="rendering"
        name="digital-house-community-container"
      />
    </div>
  </sc-render>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import { Text, Link, Placeholder } from '@sitecore-jss/sitecore-jss-vue'

import { getButtonType } from '~/helpers/get-button-type'
import { arrayUID } from '~/helpers/unique-id'
import mapFields from '~/helpers/map-fields'

import ScRender from '../sc-render'

const { mapGetters: mapJssGetters } = createNamespacedHelpers('jss')
const { mapGetters: mapEnvGetters } = createNamespacedHelpers('ui/environment')

export default {
  name: 'CommunityContainer',

  components: {
    ScText: Text,
    ScLink: Link,
    ScPlaceholder: Placeholder,
    ScRender
  },

  props: {
    fields: {
      type: Object,
      default: () => ({})
    },
    rendering: {
      type: Object
    }
  },

  withPlaceholder () {
    return {
      placeholders: [
        {
          placeholder: 'digital-house-community-container',
          computedPropName: 'tilesPlaceholder'
        }
      ]
    }
  },

  computed: {
    ...mapJssGetters(['isEditMode']),
    ...mapEnvGetters(['themeColor']),
    ...mapFields({
      title: 'title.value',
      ctaHref: 'cta.value.href',
      ctaText: 'cta.value.text',
      ctaTarget: 'cta.value.target',
      ctaHiddenText: 'cta.value.data-hidden-text'
    }),
    tiles () {
      return arrayUID(this.tilesPlaceholder)
    },
    btnLinkKey () {
      return getButtonType(this.ctaHref)
    }
  }
}
</script>

<style lang="scss" scoped>

.community-container {
  @include tablet {
    height: 100%;
  }

  .header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: $space-060 $space-050 0;

    @include tablet {
      flex-direction: column;
      justify-content: flex-start;
      padding: $space-080 0 0;
    }

    .title {
      @include font('060');
    }

    .cta-container {
      @include tablet {
        margin-top: $space-030;
      }
    }
  }

  .tiles {
    width: 100%;
    display: inline-flex;
    flex-direction: row;
    margin-top: $space-080;

    @include tablet {
      margin-top: $space-090;
    }

    > * {
      width: 100%;

      &:first-child {
        margin-left: $space-070;
        margin-right: $space-060;
      }

      &:last-child {
        padding-top: $space-090;
        margin-right: $space-070;
      }

      @include tablet {
        &:first-child {
          margin-left: 0;
          margin-right: $space-070;
        }

        &:last-child {
          padding-top: $space-120;
          margin-right: 0;
        }
      }
    }
  }

  .container-editor {
    width: 100%;
    display: inline-flex;
    margin-top: $space-090;
  }
}

</style>
